import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import {
    selectFeatureFlags,
    selectDeviceType,
} from 'yoda-site-components/lib//selectors/ContextSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { isGalleryPage } from 'yoda-site-components/lib/helpers/Utils/pageType';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import capitalize from 'lodash/capitalize';
import BreadCrumbs from 'yoda-core-components/lib/components/BreadCrumbs/BreadCrumbs';
import Crumbs from 'yoda-core-components/lib/components/BreadCrumbs/BreadCrumbs/Crumbs';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { saveAnalyticsData } from 'yoda-site-components/lib/components/BreadCrumbNav/BreadCrumb';
import analyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';

import getPDPBreadcrumbsAction from '../../actions/PDPBreadcrumbsAction';
import * as styles from './PDPBreadcrumbs.css';

const cx = classNames.bind(styles);
const defaults = {
    fromGallery: {},
    breadcrumbsData: [],
};

const breadcrumbsTheme = {
    crumbsRowClass: cx('row'),
    crumbListItemClass: cx(styles.crumbListItem),
};

const capitalizeWords = (str) => str.split(' ').map(capitalize).join(' ');

export class PDPBreadcrumbs extends Component {
    static defaultProps = {
        breadcrumbsData: {},
        actions: {},
        deviceType: {},
        featureFlags: {},
        query: {},
        ppId: null,
        fromGallery: {},
        productDetails: {},
        isNative: false,
    };

    static propTypes = {
        breadcrumbsData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]).isRequired,
        query: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        ppId: PropTypes.string.isRequired,
        fromGallery: PropTypes.oneOfType([PropTypes.object]),
        productDetails: PropTypes.oneOfType([PropTypes.object]),
        isNative: PropTypes.bool,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        const {
            ppId,
            query,
            featureFlags: { enableV2Breadcrumb = true },
        } = this.props;
        this.props.actions.getPDPBreadcrumbsAction(ppId, enableV2Breadcrumb, query);
    }

    /**
     * TODO: Create selector for this.
     */
    getBreadcrumbsForDisplay() {
        const { breadcrumbsData, deviceType, fromGallery, featureFlags, isNative } = this.props;
        let breadcrumbs = breadcrumbsData.breadcrumbs || defaults.breadcrumbsData;
        // don't modify breadcrumbs
        breadcrumbs = breadcrumbs.slice();
        if (breadcrumbs.length > 0) {
            // get the last item
            let lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
            lastBreadcrumb = { ...lastBreadcrumb };
            // slice breadcrumb for S & M breakpoints
            if (deviceType.isMobile || deviceType.isTablet) {
                breadcrumbs = [lastBreadcrumb];
            } else {
                if (!get(featureFlags, 'disableBreadcrumbsFirstItem', true)) {
                    // update first breadcumb label to jcpenney.
                    breadcrumbs[0] = { ...breadcrumbs[0], breadCrumbLabel: 'JCPenney' };
                } else {
                    // remove the first breadcrumb
                    breadcrumbs.shift(0);
                }
                breadcrumbs[breadcrumbs.length - 1] = lastBreadcrumb;
            }
            if (lastBreadcrumb.breadCrumbLabel.indexOf('back to') === -1) {
                lastBreadcrumb.breadCrumbLabel = `back to ${lastBreadcrumb.breadCrumbLabel}`;
            }
        }

        breadcrumbs = breadcrumbs.map((breadcrumb) => {
            const { breadCrumbLabel } = breadcrumb;
            if (breadCrumbLabel.includes('JCPenney')) {
                return breadcrumb;
            }
            return { ...breadcrumb, breadCrumbLabel: capitalizeWords(breadCrumbLabel) };
        });
        if (!isNative && fromGallery && fromGallery.breadcrumbs && breadcrumbs.length === 1) {
            breadcrumbs[breadcrumbs.length - 1].onClick = this.goBack;
        }
        return breadcrumbs;
    }

    goBack(e) {
        // fallback to default url if window.history is not supported.
        /* istanbul ignore else */
        if (window.history) {
            e.preventDefault();
            window.history.back();
        }
    }

    buildSchema() {
        const breadcrumbs = get(
            this.props.productDetails,
            'breadCrumbInfo.breadcrumbs',
            defaults.breadcrumbsData
        );
        let schema = false;
        if (breadcrumbs && breadcrumbs.length > 0) {
            schema = {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
            };
            const itemList = [];
            breadcrumbs.forEach((breadcrumb, idx) => {
                itemList.push({
                    '@type': 'ListItem',
                    position: idx + 1,
                    item: {
                        '@id': `https://www.jcpenney.com${breadcrumb.pageUrl}`,
                        name: breadcrumb.breadCrumbLabel,
                    },
                });
            });
            schema.itemListElement = itemList;
        }

        return schema;
    }

    renderSchema() {
        const schema = this.buildSchema();
        if (schema) {
            return (
                // dangerouslySetInnerHTML is required here to avoid encoding of quotes.
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
                /> // eslint-disable-line react/no-danger
            );
        }

        return null;
    }

    renderOnClick = (event, pageUrl) => {
        LocalStorage.setData('pdpBreadCrumbsClick', 'true');
        event.preventDefault();
        window.location = pageUrl;
    };

    renderBreadcrumbs() {
        const breadcrumbs = this.getBreadcrumbsForDisplay();
        let separator = 'slashGrayTheme';
        const {
            fromGallery,
            deviceType,
            featureFlags: {
                enableBreadcrumbsUnderlineChevron = true,
                pdpBreadCrumbzScrollTop = true,
            },
        } = this.props;
        /* istanbul ignore next */
        if (
            enableBreadcrumbsUnderlineChevron &&
            fromGallery &&
            fromGallery.breadcrumbs &&
            breadcrumbs.length === 1
        ) {
            separator = 'reverseArrow';
        } else if (enableBreadcrumbsUnderlineChevron) {
            separator = 'arrow';
        }
        return breadcrumbs.length > 0 && this.props.featureFlags.breadcrumbs ? (
            <div
                className={`${cx(styles.breadcrumbsContainer)} ${dt([
                    !deviceType.isDesktop && 'smMd:hidden',
                ])}`}
            >
                <ErrorBoundary>
                    <BreadCrumbs
                        separator={separator}
                        themeConfig={breadcrumbsTheme}
                        saveBreadCrumbAnalytics={
                            /* istanbul ignore next */
                            (...props) => saveAnalyticsData(this.props.actions, ...props)
                        }
                    >
                        {breadcrumbs.map((crumb, idx) => (
                            <Crumbs
                                path={crumb.pageUrl}
                                key={'breadcrumb-'.concat(idx)}
                                onClick={
                                    !__SERVER__ &&
                                    pdpBreadCrumbzScrollTop &&
                                    isGalleryPage(crumb.pageUrl)
                                        ? (event) => this.renderOnClick(event, crumb.pageUrl)
                                        : crumb.onClick
                                }
                            >
                                {crumb.breadCrumbLabel}
                            </Crumbs>
                        ))}
                    </BreadCrumbs>
                </ErrorBoundary>
            </div>
        ) : null;
    }

    render() {
        return (
            <>
                {this.renderBreadcrumbs()}
                {this.renderSchema()}
            </>
        );
    }
}

const mapStateToProps = (store) => ({
    breadcrumbsData: store.breadcrumbsData,
    deviceType: selectDeviceType(store),
    fromGallery: store.fromGallery || defaults.fromGallery,
    featureFlags: selectFeatureFlags(store),
    productDetails: store.productDetails,
    isNative: store.context ? store.context.isNative : {},
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ getPDPBreadcrumbsAction, ...analyticsAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PDPBreadcrumbs);
